var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { TRACKER, RECENT_ORDERS } from '@/stores/defs';
import EOrderStatus from '@Interface/Orders/EOrderStatus';
var statusMap = {
    ordering: EOrderStatus.STATUS_NONE,
    placed: EOrderStatus.STATUS_CLAIMED,
    making: EOrderStatus.STATUS_PREPARED,
    pickup: EOrderStatus.STATUS_STAGED,
    delivering: EOrderStatus.STATUS_ON_ROUTE,
    delivered: EOrderStatus.STATUS_DELIVERED,
};
var mixinName = {
    computed: __assign({}, mapGetters({
        getTrackerActive: TRACKER.GET_ACTIVE,
        getTrackerPosition: TRACKER.GET_POSITION,
        getTrackerPreviousPosition: TRACKER.GET_PREVIOUS_POSITION,
        _getActiveOrder: RECENT_ORDERS.GET_ACTIVE_ORDER,
    }), { isStatusDelivering: function () {
            return (this.getTrackerPosition === statusMap.delivering);
        },
        isStatusDelivered: function () {
            return (this.getTrackerPosition === statusMap.delivered);
        } }),
    methods: __assign({}, mapActions({
        setTrackerActive: TRACKER.SET_ACTIVE,
        setTrackerPosition: TRACKER.SET_POSITION,
        setTrackerPreviousPosition: TRACKER.SET_PREVIOUS_POSITION,
        _setActiveOrder: RECENT_ORDERS.SET_ACTIVE_ORDER,
    }), { resolveTrackerPositionForName: function (name) {
            var currentPosition = +this.getTrackerPosition;
            var previousPosition = +this.getTrackerPreviousPosition;
            var statusPosition = +statusMap[name];
            var isPastPosition = statusPosition <= previousPosition;
            if (isPastPosition && statusPosition < currentPosition) {
                return 'active';
            }
            else if (currentPosition >= statusPosition) {
                return 'active current';
            }
            else {
                return '';
            }
        },
        _resetTrackerPosition: function () {
            this.setTrackerPreviousPosition(0);
            this.setTrackerPosition(0);
        } }),
    watch: {
        getTrackerPosition: function (newValue, oldValue) {
            if (newValue === 6) {
                this._setActiveOrder(null);
            }
        },
    },
};
export default mixinName;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/trackerMixin.ts
// module id = ShJr
// module chunks = 18